import Logger from '@/utils/logger'
import { login as apiLogin, getProfile as apiGetProfile, changePassword } from '@/api/auth'

const state = {
  token: localStorage.getItem('admin_token'),
  adminInfo: null,
  isLoggedIn: false
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('admin_token', token)
  },
  SET_ADMIN_INFO(state, info) {
    state.adminInfo = info
    state.isLoggedIn = true
  },
  CLEAR_AUTH(state) {
    state.token = null
    state.adminInfo = null
    state.isLoggedIn = false
    localStorage.removeItem('admin_token')
  }
}

const actions = {
  async login({ commit }, credentials) {
    try {
      // API请求会返回格式为 {code: 200, msg: "登录成功", data: {token: "实际token值"}} 的响应
      const response = await apiLogin(credentials)
      
      // 检查响应是否成功
      if(response.code === 200 && response.data && response.data.token) {
        // 设置token到状态和本地存储
        commit('SET_TOKEN', response.data.token)
        
        // 如果需要，可以在这里获取管理员信息
        // await store.dispatch('auth/getProfile')
      } else {
        // 如果API返回错误，抛出错误
        throw new Error(response.msg || '登录失败')
      }
      
      // 记录登录日志
      Logger.recordAuthAction('登录', 
        { username: credentials.username },
        { success: true, token: response.data.token }
      )
      
      return response
    } catch (error) {
      // 记录登录失败日志
      Logger.recordAuthAction('登录失败', 
        { username: credentials.username },
        { success: false, error: error.message }
      )
      throw error
    }
  },
  
  async logout({ commit, state }) {
    try {
      // 记录登出日志
      Logger.recordAuthAction('登出', 
        { admin_id: state.adminInfo?.id },
        { success: true }
      )
      
      commit('CLEAR_AUTH')
      
      return { success: true }
    } catch (error) {
      console.error('登出失败:', error)
      // 清除本地状态
      commit('CLEAR_AUTH')
      throw error
    }
  },
  
  async getProfile({ commit }) {
    try {
      const response = await apiGetProfile()
      commit('SET_ADMIN_INFO', response.data)
      return response
    } catch (error) {
      console.error('获取管理员信息失败:', error)
      throw error
    }
  },
  
  async changePassword({ commit }, { oldPassword, newPassword }) {
    try {
      const response = await changePassword({
        old_password: oldPassword,
        new_password: newPassword
      })
      
      if (response.code === 200) {
        // 修改密码成功，记录日志
        Logger.recordAuthAction('修改密码', 
          { admin_id: state.adminInfo?.id },
          { success: true }
        )
        
        // 密码修改成功后清除本地缓存并退出登录，让用户重新登录
        commit('CLEAR_AUTH')
        
        return response
      } else {
        throw new Error(response.msg || '修改密码失败')
      }
    } catch (error) {
      // 记录修改密码失败日志
      Logger.recordAuthAction('修改密码失败', 
        { admin_id: state.adminInfo?.id },
        { success: false, error: error.message }
      )
      throw error
    }
  }
}

const getters = {
  isAuthenticated: state => !!state.token,
  adminInfo: state => state.adminInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}